import { render, staticRenderFns } from "./HeaderTab.vue?vue&type=template&id=a3076db4&scoped=true&"
import script from "./HeaderTab.vue?vue&type=script&lang=js&"
export * from "./HeaderTab.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTab.vue?vue&type=style&index=0&id=a3076db4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3076db4",
  null
  
)

export default component.exports